const serverUrl = process.env.REACT_APP_SERVER_URL;

export default serverUrl;
